import { qs, qsa, delegate, on } from '../helpers';
import InputOptions from './input_options';

export default class View {
	constructor() {

		this.profilePage = qs('.page.profile');
		this.initialized = true;

		// find all relevant elements
		this.contactInformation = qs('.contact-information', this.profilePage);

		this.accountInformation = qs('.account-information', this.profilePage);

		this.firstNameInput = qs('.row.first-name input', this.contactInformation);
		this.middleNameInput = qs('.row.middle-name input', this.contactInformation);
		this.lastNameInput = qs('.row.last-name input', this.contactInformation);
		this.birthdayInput = qs('.row.birthday input', this.contactInformation);
		this.genderInput = qs('.row.gender input', this.contactInformation);
		this.ethnicityInput = qs('.row.ethnicity input', this.contactInformation);

		this.editInformationButton = qs('.contact-information .button.toggle-edit', this.profilePage);
		this.saveChangesButton = qs('.contact-information .button.save-changes', this.profilePage);
		this.disregardChangesButton = qs('.contact-information .button.disregard-changes', this.profilePage);

		this.genderOptionsContainer = qs('.column.value.gender', this.profilePage);
		new InputOptions(this.genderOptionsContainer);

		this.enthinictyOptionsContainer = qs('.column.value.ethnicity', this.profilePage);
		new InputOptions(this.enthinictyOptionsContainer);

		this.setupClickListeners();
	}

	setupClickListeners() {
		on(this.editInformationButton, "click", () => {
			this.enableFormEdit();
		});
	}

	enableFormEdit() {
		this.editInformationButton.classList.add("hidden");
		this.saveChangesButton.classList.remove("hidden");
		this.disregardChangesButton.classList.remove("hidden");

		this.enableInputs();
	}

	hasAnyFormErrors() {
		return qs('.field-validation-error') !== null;
	}

	bindDisregardChangeButton(handler) {
		on(this.disregardChangesButton, "click", () => {
			handler();
		});
	}

	bindFirstNameChange(handler) {
		on(this.firstNameInput, 'keyup', ({ target }) => {
			const value = target.value.trim();
			handler(value);
		});
	}

	// restore the view
	resetView(firstName, middleName, lastName, birthday, gender, ethnicity) {
		if (!this.initialized) {
			return;
		}
		this.editInformationButton.classList.remove("hidden");
		this.saveChangesButton.classList.add("hidden");
		this.disregardChangesButton.classList.add("hidden");
		this.disableInputs();

		this.firstNameInput.value = firstName;
		this.middleNameInput.value = middleName;
		this.lastNameInput.value = lastName;
		this.birthdayInput.value = birthday == "aN-aN-NaN" ? "" : birthday;
		this.genderInput.value = gender;
		this.ethnicityInput.value = ethnicity;
	}

	enableInputs() {
		qsa(".column.value input", this.contactInformation).forEach(e => {
			e.classList.add("edit");
			e.disabled = false;
		})

		this.profilePage.classList.add("edit-active");
	}

	disableInputs() {
		qsa(".column.value input", this.contactInformation).forEach(e => {
			e.classList.remove("edit");
			e.disabled = true;
		})

		this.profilePage.classList.remove("edit-active");
	}

	get firstName() {
		return this.firstNameInput.value;
	}

	get middleName() {
		return this.middleNameInput.value;
	}

	get lastName() {
		return this.lastNameInput.value;
	}

	get birthday() {
		return new Date(this.birthdayInput.value.replace(/-/g, "/"));
	}

	get gender() {
		return this.genderInput.value;
	}

	get enthinicty() {
		return this.ethnicityInput.value;
	}
}
